import { Http } from './http';
import { CreditCall } from '@types';

class CreditCallHttp extends Http {
  prefix = 'credit-call';

  async getCallsByCredit(creditId: number): Promise<CreditCall[]> {
    const res = await this.get<CreditCall[]>(`/by-credit/${creditId}`);

    return res.data;
  }

  async removeCalls(callIds: number[]): Promise<number> {
    await this.delete<CreditCall>('/remove', { callIds });

    return callIds.length;
  }

  async updateBulk(params: BulkUpdateParams): Promise<number> {
    const res = await this.put<number>('/update-bulk', params);

    return res.data;
  }
}

export const creditCallHttp = new CreditCallHttp();

interface BulkUpdateParams {
  selectedIds: number[];
  prop: string;
  value: number | string;
}
